import { useSelector, shallowEqual } from "react-redux";
import CorporateSite from "app/pages/CorporateSite/CorporateSite.jsx";

const mapStateToProps = state => {
	return {
		resolution: state.resolution,
	};
};

const CorporateSiteContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	return <CorporateSite {...props} {...stateProps} />;
};

export default CorporateSiteContainer;
